// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yi14C","cards":"styles_cards__C-6+i","card":"styles_card__hxegx"};